module.exports = __webpack_public_path__ + "static/media/16.6851c43e.png";